(function () {
  'use strict';

  var activeClass = 'site-nav--active-dropdown';

  function positionPanels() {
    document.querySelectorAll('[data-krono-mega-panel]').forEach(function (panel) {
      panel.style.removeProperty('top');
    });
  }

  function closeAll(items) {
    items.forEach(function (item) {
      item.classList.remove(activeClass);
      var trigger = item.querySelector('.site-nav__link--main');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openItem(item, items) {
    closeAll(items);
    item.classList.add(activeClass);
    var trigger = item.querySelector('.site-nav__link--main');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    positionPanels();
  }

  function initKronoMegaMenuDesktop() {
    var menu = document.querySelector('[data-krono-mega-menu]');
    if (!menu) return;

    var items = menu.querySelectorAll('[data-krono-mega-item]');

    items.forEach(function (item) {
      var panel = item.querySelector('[data-krono-mega-panel]');
      if (!panel) return;

      item.addEventListener('mouseenter', function () {
        openItem(item, items);
      });

      item.addEventListener('mouseleave', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            item.classList.remove(activeClass);
            var trigger = item.querySelector('.site-nav__link--main');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          }
        }, 120);
      });

      item.addEventListener('focusin', function () {
        openItem(item, items);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        item.classList.remove(activeClass);
        var trigger = item.querySelector('.site-nav__link--main');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-krono-mega-menu]')) return;
      closeAll(items);
    });

    window.addEventListener('resize', positionPanels);
    positionPanels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKronoMegaMenuDesktop);
  } else {
    initKronoMegaMenuDesktop();
  }
})();
